// extracted by mini-css-extract-plugin
module.exports = {"hover-zoom-container":"_name__hover-zoom-container__puK1z","transform-gpu":"_name__transform-gpu__2_AAO"};